import { clsx } from 'clsx';

interface ILoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  label?: string;
}

export function LoadingSpinner({ 
  size = 'md', 
  className,
  label = 'Loading...'
}: ILoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'h-4 w-4 border-2',
    md: 'h-8 w-8 border-2',
    lg: 'h-12 w-12 border-3',
  };

  return (
    <div className={clsx('flex flex-col items-center justify-center gap-3', className)}>
      <div
        className={clsx(
          'animate-spin rounded-full border-primary-600 border-t-transparent',
          sizeClasses[size]
        )}
        role="status"
        aria-label={label}
      />
      {size === 'lg' && (
        <span className="text-sm text-gray-500">{label}</span>
      )}
      <span className="sr-only">{label}</span>
    </div>
  );
}



